import React from 'react'
import Modal from 'react-bootstrap/Modal'

const SCHOOLS = [
  {
    school_id: 0,
    school_name: 'İlkokul',
  },
  {
    school_id: 1,
    school_name: 'Ortaokul',
  },
  {
    school_id: 2,
    school_name: 'Lise',
  },
  {
    school_id: 3,
    school_name: 'Üniversite',
  },
]

const SchollModal = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      style={{
        userSelect: 'none',
      }}
      size={20}
      //   backdrop='static'
      centered
    >
      <Modal.Body className=''>
        {SCHOOLS?.map((item) => (
          <div
            className='ilceItem'
            key={item.school_id}
            onClick={() => {
              props.setSelectedSchoolId(item.school_id)
              props.setSelectedSchool(item.school_name)
              props.setSchoolClass()
              props.onHide()
            }}
          >
            {item.school_name}
          </div>
        ))}
        <div
          style={{ position: 'absolute', top: '15px', right: '15px' }}
          onClick={props.onHide}
        >
          X
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SchollModal
